import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { Context } from 'components/AppContext'

const Button = ({
    className,
    loading = false,
    children,
    trackName,
    trackLabel = '',
    ...props
}) => {
    return (
        <Context.Consumer>
            {context => {
                const contextName = context.join('.')
                return (
                    <button
                        className={classNames(
                            { 'loading loading--secondary': loading },
                            className
                        )}
                        data-track-context={contextName}
                        data-track-name={trackName}
                        data-track-label={trackLabel}
                        {...props}
                    >
                        {children}
                    </button>
                )
            }}
        </Context.Consumer>
    )
}

Button.propTypes = {
    type: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    trackName: PropTypes.string.isRequired,
    trackLabel: PropTypes.string,
}

export default Button
